import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchUsersData, fetchQueuesData, fetchWrapUpCodesData } from "./data/filtersData"
import { client } from "../../api/client"

const apiURL = process.env.REACT_APP_GENESYS_API_URL
const staticApiUrl = process.env.REACT_APP_STATIC_LISTS_API_URL

const initialState = {
    users: [],
    qs: [],
    wrapUpCodes: [],
    searchFields: {
        searchTerm: '',
        fromDate: '',
        fromTime: '',
        toDate: '',
        toTime: '',
        conversationId: '',
        contact: '',
        direction: '',
        user: '',
        q: '',
        wrapUpCodes: [],
        commaSeparatedWrapUpCodes: ''
    },
    status: 'idle',
    error: null,
}

export const fetchWrapUpCodes = createAsyncThunk('filters/fetchWrapUpCodes', async () => {
    const data = await fetchWrapUpCodesData();
    console.log('fetchWrapUpCodes', data);
    return data;
});

export const fetchUsers = createAsyncThunk('filter/fetchUsers', async () => {
    const data = await fetchUsersData();
    console.log('fetchUsers', data);
    return data;
})

export const fetchQs = createAsyncThunk('filter/fetchQs', async () => {
    const data = await fetchQueuesData();
    console.log('fetchQs', data);
    return data;
    if (process.env.REACT_APP_DISABLE_WRAPUPCODES === 'true') {
        console.log('fetchWrapUpCodes disabled by environment variable')
        return [] // return empty array when disabled
    }
    if (staticApiUrl) {
        const response = await client.get(staticApiUrl, '/wrapupcodes')
        console.log('fetchWrapUpCodes', response.data)
        return response.data;
    } else {
        const response = await client.get(apiURL, '/Stage?entitytype=WrapupCode');
        console.log('fetchWrapUpCodes', response.data);
        return response.data;
    }
});

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setSearchFields(state, action) {
            state.searchFields = action.payload;
        },
        clearSearchFields(state) {
            state.searchFields = initialState.searchFields;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUsers.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.status = 'succeeded'
                // Add any fetched users to the array
                state.users = action.payload
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            .addCase(fetchQs.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchQs.fulfilled, (state, action) => {
                state.status = 'succeeded'
                // Add any fetched qs to the array
                state.qs = action.payload
            })
            .addCase(fetchQs.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            .addCase(fetchWrapUpCodes.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchWrapUpCodes.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.wrapUpCodes = action.payload
            })
            .addCase(fetchWrapUpCodes.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
    }
})

export const { setSearchFields, clearSearchFields } = filterSlice.actions

export default filterSlice.reducer

export const selectAllUsers = (state) => state.filter.users;
export const selectAllQs = (state) => state.filter.qs;
export const selectSearchFields = (state) => state.filter.searchFields;
export const selectWrapUpCodes = (state) => state.filter.wrapUpCodes;